import { AreaChartModel } from '../models/chart/area-chart.model';
import { ChartStylingModel } from '../models/chart/chart-styling.model';

export const /** @type {?} */ AreaChartTemplates = {
  defaultTemplate: {
    property: new AreaChartModel({
      display: true,
      disable: false,
      autoScale: false,
      stacked: false,
      gradient: false,
      showLegend: true,
      legendPosition: 'right',
      chartAlignment: 'start',
      colorSchemeName: 'forest',
      colorScheme: {
        domain: []
      },
      showXAxis: true,
      showYAxis: true,
      showXAxisLabel: true,
      showYAxisLabel: true,
      xAxisLabel: '',
      yAxisLabel: '',
    }),
    style: new ChartStylingModel({
      barsContainerWidth: '100%',
      barsContainerHeight: '200px'
    })
  }
}
